import AnalyticsMetricContainer from "./component";
import AnalyticsContainer from "./container";

export { AnalyticsContainer, AnalyticsMetricContainer };
export default AnalyticsContainer;



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/AnalyticsContainer/index.ts